module.exports = new __parcel__URL__("Teona_Tchigladze.10bb189e.jpg").toString();